import { Box, Button, Stack, Typography } from '@mui/material';
import { Button1, Button3 } from 'components/Button';
import CusDataGrid from 'components/CusDataGrid';

export const userEditFields = ({ t, userProjsRoles, companyOptions, isNew, onAddPermission, onDelete }) => {
  const registrationFields = isNew
    ? [
        {
          label: (
            <Box display="flex" flexDirection="row">
              {t('PASSWORD')}
              <Typography color="red" ml={1}>
                *
              </Typography>
            </Box>
          ),
          id: 'Password',
          // cProps: {
          //   rules: {
          //     required: true
          //   }
          // },
          fieldProps: {
            required: true
          },
          type: 'password'
        },
        {
          label: (
            <Box display="flex" flexDirection="row">
              {t('CONFIRM_PW')}
              <Typography color="red" ml={1}>
                *
              </Typography>
            </Box>
          ),
          id: 'ConfirmPassword',
          fieldProps: {
            required: true
          },
          type: 'password'
        }
      ]
    : [];

  return [
    {
      label: (
        <Box display="flex" flexDirection="row">
          {t('USER')}
          <Typography color="red" ml={1}>
            *
          </Typography>
        </Box>
      ),
      id: 'UserName',

      fieldProps: {
        disabled: true,
        required: true
      }
    },
    {
      label: (
        <Box display="flex" flexDirection="row">
          {t('FULL_NAME')}
          <Typography color="red" ml={1}>
            *
          </Typography>
        </Box>
      ),
      id: 'FullName',

      fieldProps: {
        // disabled: !isNew,
        required: true
      }
    },
    {
      label: (
        <Box display="flex" flexDirection="row">
          {t('MOBILE')}
          <Typography color="red" ml={1}>
            *
          </Typography>
        </Box>
      ),
      id: 'PhoneNumber',
      fieldProps: {
        required: true
      }
    },
    {
      label: (
        <Box display="flex" flexDirection="row">
          {t('EMAIL')}
          <Typography color="red" ml={1}>
            *
          </Typography>
        </Box>
      ),
      id: 'Email',
      fieldProps: {
        required: true
      }
    },
    {
      label: (
        <Box display="flex" flexDirection="row">
          {t('TEAM')}
          <Typography color="red" ml={1}>
            *
          </Typography>
        </Box>
      ),
      fieldProps: {
        required: true
      },
      id: 'Team'
    },
    ...registrationFields,
    {
      label: (
        <Box display="flex" flexDirection="row">
          {t('COMPANY')}
          <Typography color="red" ml={1}>
            *
          </Typography>
        </Box>
      ),
      id: `CompanyId`,
      fieldProps: {
        required: true
      },
      type: 'select',
      options: companyOptions
    },
    {
      label: (
        <Box display="flex">
          {t('PERMISSION')} <span className="text-danger">*</span>
        </Box>
      ),
      id: 'Permission',

      // colProps: { className: 'd-flex flex-column align-items-start' },
      cusInput: (
        <Stack direction="column" width={'100%'}>
          <CusDataGrid
            hideFooter
            showToolbar={false}
            rows={userProjsRoles}
            getRowId={(r) => r.Permission}
            columns={[
              {
                headerName: t('PERMISSION'),
                field: 'Permission',
                width: 200
              },
              {
                headerName: t('DELETE'),
                width: 100,
                field: 'Delete',
                renderCell: ({ row }) => (_.isEmpty(row) ? null : <Button onClick={() => onDelete(row)}>X</Button>)
              }
            ]}
          />

          <Button1 text={t('ADD_PERMISSION')} variant="contained" onClick={onAddPermission} />
        </Stack>
      )
    }
  ];
};
